<style>
select {
    height: auto;
}
</style>
<template>
    <div class="invites">
        <validation-error :messages="errors.registration_code_id"></validation-error>
        <div class="form-group">
            <label>Recipient Email:</label>
            <BFormInput v-model="newInvite.to_email" type="email"></BFormInput>
            <validation-error :messages="errors.to_email"></validation-error>
        </div>
        <div class="form-group">
            <label>Recipient Name:</label>
            <input class="form-control" v-model="newInvite.to_name" type="text">
            <validation-error :messages="errors.to_name"></validation-error>
        </div>
        <div class="form-group">
            <label>Recipient Type:</label>
            <BFormSelect plain v-model="newInvite.to_role" :options="recipientOptions" />
            <validation-error :messages="errors.to_role"></validation-error>
        </div>
        <button class="btn btn-orange-blue" @click="createInvite" :disabled="sending">
            {{submitText}}
        </button>
    </div>
</template>
<script>
    import ValidationError from '../ValidationError'
    export default {
        components: {
            ValidationError
        },
        props: {
            code: {
                required: true,
                type: Object
            }
        }, 
        data() {
            return {
                newInvite: {},
                recipientOptions: [
                    { text: 'Program User', value: 'program-user' },
                    { text: 'TA Consultant', value: 'ta-consultant' },
                    { text: 'Partner User', value: 'partner-user' }
                ],
                errors: {},
                sending: false
            }
        },
        computed: {
            submitText: function () {
                return this.sending ? 'Sending Invite' : 'Submit';
            }
        },
        methods: {
            initNewInvite() {
                this.newInvite = {
                    registration_code_id: this.code.id,
                    to_name: null,
                    to_email: null,
                    create_form: true
                }
            },
            createInvite() {
                this.sending = true;
                axios.post('/api/invites', this.newInvite)
                    .then((response) => {
                        this.$emit('inviteCreated', { inviteCreatedId: response.data.data.id })
                        this.initNewInvite()
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors
                    })
                    .then(response => {
                        this.sending = false
                    })
            }
        },

        watch: {
            code: function() {
                this.initNewInvite()
            }
        },

        mounted() {
            this.initNewInvite()
        }
    }
</script>